import * as React from 'react';
import { useGetPricingProfileQuery } from "../../../apis/PricingProfile.api";
import { PrimaryPricingProfile, PricingProfile } from "../../../types/models/PricingProfile";
import {displayDateTime, displayDate, displayTime} from "../../../../utils/formatDate";

type IDisplayProps = {
    data: PricingProfile;
};

export const PricingProfileNameDisplay: React.FC<IDisplayProps> = ({data}) => {
    if (data) {
        return (<>{ data?.name }
                    </>)
    } else {
        return undefined
    }
}

type INameProps = {
    id: ID;

};

const PricingProfileName: React.FC<INameProps> = ({id}) => {
    const { data } = useGetPricingProfileQuery(PrimaryPricingProfile.fromId(id))
    return (<PricingProfileNameDisplay data={data}/>)
}

export default PricingProfileName;
